<template lang="pug">
  Accordion(:startOpen="false")
    template(slot="heading")
      span.fs-19(style="text-align: center;")
        slot

    template
      .flex
        TransitionExpand
          template(v-for="(item, index) in state")
            PTextField(v-model="item.field" label="nome do campo" name="item.text" required :key="index + 'field'")
            PTextField(v-model="item.text" label="valor do campo" name="item.text" :key="index + 'value'")

            span(:key="index + 'span1'")
            span(:key="index + 'span2'")

          template(v-for="(item, index) in newFields")
            PTextField(v-model="item.field" label="nome do campo" name="item.text" required v-focus  :key="index + 'newfield'")
            PTextField(v-model="item.text" label="valor do campo" name="item.text"  :key="index + 'newvalue'")

            span.buttons(:key="'apply' + index")
              PButton(size="md" color="success" @click="apply(index)" :disabled="!validToApply(index)" block)
                .icon.icon-ptt-icons-adicionar
            span.buttons(:key="'cancel' + index")
              PButton(size="md" color="danger" @click="changeAddMode(false, index)" block)
                .icon.icon-ptt-icons-excluir

      PButton(color="success" size="md" @click="changeAddMode(true)" v-if="!disabled") adicionar novo campo

</template>

<script>
import { handlerUseStateVmodel } from 'src/common/mixins/handlerUseStateVmodel'

export default {
  name: 'CustomFields',
  mixins: [handlerUseStateVmodel(true)],
  props: {
    disabled: Boolean
  },
  data () {
    return {
      newFields: []
    }
  },
  methods: {
    validToApply (index) {
      return this.newFields[index].field.length > 2
    },
    changeAddMode (mode, removeIndex = null) {
      if (mode) {
        this.newFields.push({text: '', field: ''})
      }
      if (removeIndex !== null) {
        this.newFields = [...this.newFields.slice(0, removeIndex), ...this.newFields.slice(removeIndex + 1)]
      }
    },
    apply (index) {
      this.state = [...this.state, this.newFields[index]]
      this.newFields = [...this.newFields.slice(0, index), ...this.newFields.slice(index + 1)]
    }
  }
}
</script>

<style scoped lang="scss">
.flex {
  &> span {
    display: grid;
    padding: 20px 0px;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 0.3fr) minmax(0, 0.3fr);
    grid-column-gap: 10px;
    align-items: baseline;

    span.buttons {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
